import type { ComponentStyleConfig } from '@chakra-ui/theme';

export const styleConfig: ComponentStyleConfig = {
  baseStyle: {
    borderBottom: {
      base: 'none',
      md: '1px solid',
    },
    borderColor: {
      base: 'transparent',
      md: 'grey.100',
    },
    fontSize: 'md',
    px: '6',
    py: '6',
  },
};
